<template>
  <div class="footer">
    <p>
      © {{ year }} - {{ year + 1 }} Copyright <a href="#">Dating4Pets</a> | All
      Rights Reserved
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      year: "",
    };
  },
  mounted() {
    this.year = new Date().getFullYear();
    // console.log(`Year: ${this.year}`);
  },
};
</script>

<style scoped>
* {
  /* color: var(--light-clr); */
  color: var(--dark-clr);
}

.footer {
  position: absolute;
  bottom: 0;
  background: var(--light-clr);
  /* background: var(--primary-clr); */
  width: 100%;
  height: 3em;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--light-box-shadow);
}

a {
  transition: var(--transition);
}

a:hover,
a:focus {
  color: var(--primary-clr);
  /* color: var(--dark-clr); */
}
</style>
